import React from 'react';

import CustomFilter from '../helper/CustomFilter';

const TableHeader = ({ headerGroup, flexRender, table }) => {
    return (
        <tr key={headerGroup.id}>
            {headerGroup.headers.map(header => {
                let style = {
                    whiteSpace: "nowrap",
                    width: header.getSize() !== 150 ? header.getSize() : undefined
                };
                
                if (header.column.columnDef.maxSize !== 9007199254740991) {
                    style.maxWidth = header.column.columnDef.maxSize;
                }

                if (header.column.columnDef.minSize != 20) {
                    style.minWidth = header.column.columnDef.minSize;
                }


                return (
                    <th key={header.id} style={style}>
                        {header.isPlaceholder ? null : (
                            <>
                                <div {...{
                                    className: header.column.getCanSort()
                                        ? 'cursor-pointer select-none'
                                        : '',
                                    onClick: header.column.getToggleSortingHandler(),
                                }}>
                                    {{
                                        asc: <i className="fa-solid fa-sort-up mr-1"></i>,
                                        desc: <i className="fa-solid fa-sort-down mr-1"></i>,
                                    }[header.column.getIsSorted()] ?? (header.column.getCanSort() ? <i className="fa-solid fa-sort mr-1"></i> : null)}
                                    {flexRender(
                                        header.column.columnDef.header,
                                        header.getContext()
                                    )}
                                    
                                </div>
                                {header.column.getCanFilter() ? (
                                    <div>
                                        <CustomFilter column={header.column} table={table} />
                                    </div>
                                ) : null}
                            </>
                        )}
                    </th>
                )
            })}
        </tr>
    );
};

export default TableHeader;